module.exports = "/assets/f7934dd21f8311d3c51d4fd3a218033a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EY.png
// module id = 2479
// module chunks = 0